export const Token = {
    'en': 'token text [TOKEN]',
    'zh-tw': '權杖[TOKEN]',
};

export const SendMessage = {
    'en': 'send the message [MESSAGE]',
    'zh-tw': '送出訊息[MESSAGE]',
};

export const TokenNull ={
    'en': 'Token or Message is null',
    'zh-tw': '權杖或傳送訊息錯誤',
}

export const SendstickerId ={
    'en': 'set Package ID [StickerPackageId] Sticker ID [STICKERId]',
    'zh-tw': '設定表情主題[StickerPackageId]表情代號[STICKERId] ',
}

export const SendImageFile ={
    'en': 'send the image file[URL]',
    'zh-tw': '傳送圖片[URL]',
}

export const checkOut ={
    'en': 'check out Line sticker definitions',
    'zh-tw': '查閱表情主題與代號',
}


